import { AsyncActionState, setupSlice } from '@owl-frontend/redux';

export interface LocalizationState {
  messages: {
    [key: string]: string;
  };
  locale: 'en-us';
  actions: {
    fetchMessages: AsyncActionState;
  };
}

const initialState: LocalizationState = {
  messages: {},
  locale: 'en-us',
  actions: {
    fetchMessages: { status: 'uninitialized' },
  },
};

const localizationSlice = setupSlice('localization', initialState);
export default localizationSlice;
